import { render, staticRenderFns } from "./RmaShippingStatus.vue?vue&type=template&id=67f99420&scoped=true&"
import script from "./RmaShippingStatus.vue?vue&type=script&lang=js&"
export * from "./RmaShippingStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f99420",
  null
  
)

export default component.exports